import {useCallback, useState} from 'react'
import {Button, Spinner} from '@primer/react'
import styles from './FooterActions.module.css'

interface FooterActionsProps {
  disabled?: boolean
  onCancel: () => void
  onApply: () => void
  checkStatus?: (callback: () => void) => void
  showError?: boolean
  nextFocusRef?: React.RefObject<HTMLElement>
  overrideButtonStyles?: React.CSSProperties
}

function FooterActions(props: FooterActionsProps) {
  const [showLoading, setShowLoading] = useState(false)

  const onBlur: React.FocusEventHandler<HTMLElement> = useCallback(() => {
    props.nextFocusRef?.current?.focus()
    return true
  }, [props.nextFocusRef])

  const displayLoading = useCallback(() => {
    setShowLoading(true)
  }, [])

  const onApply = useCallback(() => {
    props.onApply()

    setTimeout(() => {
      if (props?.checkStatus) props.checkStatus(displayLoading)
    }, 600)
  }, [props, displayLoading])

  return (
    <div className={styles.footerContainer}>
      {props.showError ? <span className={styles.errorMessageText}>Error. Please try again.</span> : null}
      <div className={styles.buttonsContainer} style={props.overrideButtonStyles ?? {padding: 'var(--base-size-16)'}}>
        {!props.showError && showLoading ? <Spinner size="small" className={styles.FooterActionsSpinner} /> : null}
        <Button
          size="small"
          onClick={() => props.onCancel()}
          onBlur={event => {
            if (props.disabled) {
              onBlur(event)
            }
          }}
        >
          Cancel
        </Button>
        <Button
          disabled={props.disabled}
          variant="primary"
          size="small"
          onClick={() => onApply()}
          onBlur={onBlur}
          className={styles.applyButton}
        >
          Apply
        </Button>
      </div>
    </div>
  )
}

export default FooterActions

try{ FooterActions.displayName ||= 'FooterActions' } catch {}